// Map boat name to a hero photo and a card thumbnail.
const SIDE_39 = "/boat-39-side.jpg";
const REAR_39 = "/boat-39-rear.jpg";
const SIDE_33 = "/boat-33-side.jpg";
const REAR_33 = "/boat-33-rear.jpg";

export function boatImage(boat, variant = "card") {
  if (!boat) return SIDE_39;
  // Admin-configured custom image (uploaded URL or picked from library)
  // wins over heuristics.
  if (boat.image_url) return boat.image_url;
  const isSmall = boat.length_ft === 33 || boat.name?.includes("Kragerø");
  if (variant === "rear") return isSmall ? REAR_33 : REAR_39;
  return isSmall ? SIDE_33 : SIDE_39;
}

export function heroImage() {
  return REAR_39;
}
